export default "__VITE_ASSET__BykA81uM__"